import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'antd'
import { DatePicker } from '@surecompanies/core_components'
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux'
import { change } from 'redux-form'
import { shouldAskForRehireDate } from './rehire-date'

const FORM_NAME = 'addEmployee'

const RehireDatePrompt = ({ employmentStatus }) => {
  const dispatch = useDispatch()
  const previousStatus = useRef(employmentStatus)
  const [open, setOpen] = useState(false)
  const [date, setDate] = useState('')

  useEffect(() => {
    const before = previousStatus.current
    previousStatus.current = employmentStatus
    if (!shouldAskForRehireDate(before, employmentStatus)) return
    setDate('')
    setOpen(true)
  }, [employmentStatus])

  return (
    <Modal
      title="Rehire date"
      open={open}
      zIndex={1002}
      onCancel={() => setOpen(false)}
      footer={
        <>
          <Button
            onClick={() => {
              dispatch(change(FORM_NAME, 'RehireDate', ''))
              setOpen(false)
            }}
          >
            No rehire date
          </Button>
          <Button
            type="primary"
            disabled={date === ''}
            onClick={() => {
              dispatch(change(FORM_NAME, 'RehireDate', date))
              setOpen(false)
            }}
          >
            Use this date
          </Button>
        </>
      }
    >
      <p>Does this employee have a rehire date?</p>
      <DatePicker
        value={date ? dayjs(date) : null}
        format="MM/DD/YYYY"
        placeholder="mm/dd/yyyy"
        onChange={(picked) =>
          setDate(picked ? picked.format('YYYY-MM-DD') : '')
        }
      />
    </Modal>
  )
}

export default RehireDatePrompt
